/* Diegmark: banner principal + animaciones */
(() => {
  const root = document.documentElement;
  root.classList.add('dgm-js');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const design = !!(window.Shopify && window.Shopify.designMode);

  function initHero(el) {
    if (!el || el.__dgm) return;
    el.__dgm = true;
    const slides = [...el.querySelectorAll('.dgm-hero__slide')];
    const dots = [...el.querySelectorAll('.dgm-hero__dot')];
    const secs = parseInt(el.dataset.autoplay || '0', 10);
    const auto = secs > 0 && slides.length > 1 && !reduce;
    el.style.setProperty('--dgm-autoplay', secs + 's');
    if (!auto) el.classList.add('no-autoplay');
    let i = 0, timer = null, x0 = null;
    const schedule = () => { clearTimeout(timer); if (auto && !el.classList.contains('is-paused') && !document.hidden) timer = setTimeout(() => go(i + 1), secs * 1000); };
    const go = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
      dots.forEach((d, k) => { d.classList.remove('is-active'); void d.offsetWidth; if (k === i) d.classList.add('is-active'); });
      schedule();
    };
    el.querySelector('[data-next]')?.addEventListener('click', () => go(i + 1));
    el.querySelector('[data-prev]')?.addEventListener('click', () => go(i - 1));
    dots.forEach((d) => d.addEventListener('click', () => go(+d.dataset.go)));
    if (window.matchMedia('(hover: hover)').matches) {
      el.addEventListener('mouseenter', () => { el.classList.add('is-paused'); clearTimeout(timer); });
      el.addEventListener('mouseleave', () => { el.classList.remove('is-paused'); go(i); });
    }
    el.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 45) go(i + (dx < 0 ? 1 : -1)); x0 = null; });
    document.addEventListener('visibilitychange', schedule);
    el.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') go(i + 1); if (e.key === 'ArrowLeft') go(i - 1); });
    document.addEventListener('shopify:block:select', (e) => { const idx = slides.indexOf(e.target.closest && e.target.closest('.dgm-hero__slide')); if (idx > -1) { el.classList.add('is-paused'); go(idx); } });
    schedule();
  }

  function initReveal() {
    if (reduce || design || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
    }), { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    document.querySelectorAll('main .shopify-section').forEach((s, idx) => {
      if (idx === 0 || s.querySelector('.dgm-hero')) return;
      if (s.getBoundingClientRect().top < window.innerHeight * 0.85) return;
      s.querySelectorAll('product-card, .collection-card').forEach((c, k) => c.style.setProperty('--dgm-i', Math.min(k, 7)));
      s.classList.add('dgm-reveal-target');
      io.observe(s);
    });
  }

  function onScroll() { root.classList.toggle('dgm-scrolled', window.scrollY > 8); }

  function init() {
    document.querySelectorAll('[data-dgm-hero]').forEach(initHero);
    initReveal();
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-dgm-hero]').forEach(initHero));
})();
